import Toastable from '@/mixins/toastable';
import AsyncComputable from '@/mixins/asyncComputable';

export default {
  mixins: [Toastable, AsyncComputable],
  components: {
    Loading: () => import('@/components/core/Loading.vue'),
  },
  asyncComputed: {
    resource: {
      get() {
        return this.resourceService
          .get(this.$route.params.resource_id, this.resourceParams)
          .then((resource) => {
            return resource.data;
          });
      },
      default: {},
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
  computed: {
    siteId() {
      return this.$route.params.site_id;
    },
    destination() {
      if (this.siteId) {
        return `/sites/${this.siteId}/${this.urlFragment}`;
      } else {
        return `/admin/${this.urlFragment}`;
      }
    },
  },
  methods: {
    cancel() {
      this.$router.push(this.destination);
    },
    submit(resource) {
      return this.resourceService
        .update(resource)
        .then((result) => {
          const name = result.data.name || resource.email || '';
          this.successToast(`Updated ${name}!`);
          this.$router.push(this.destination);
        })
        .catch(this.failToast);
    },
    destroy(resource) {
      if (!window.confirm('Are you sure you want to delete this item?')) {
        return;
      }
      return this.resourceService
        .destroy(resource)
        .then(() => {
          const name = resource.name || resource.email || '';
          this.successToast(`Deleted ${name}!`);
          this.$router.push(this.destination);
        })
        .catch(this.errorToast);
    },
  },
};
